let $ = require('jquery');
// Add in globally accessible aliases (w/o another JS, like slick, might not get access to $)
window.jQuery = $;
window.$ = $;

require('popper.js');
require('bootstrap/dist/js/bootstrap.bundle');

// Add in all dependencies, except for those that need to be overwritable inside other extensions
import 'slick-carousel/slick/slick';

// Import mmenu 
import 'jquery.mmenu/dist/jquery.mmenu.all';

// Add in here your initial (global) setup, if necessary
(function() {
	require('./components/mmenu');
	require('./components/slider.js');
	require('./components/browser-compatibility.js');

	// Language switcher
	let btnLangSwitcher = document.querySelector('#langSwitchPopover .js-btn-langpage');
	let selCountrySwitch = document.querySelector('#langSwitchPopover .js-sel-country');
	let selLangSwitch = document.querySelector('#langSwitchPopover .js-sel-language');
	if (selCountrySwitch && btnLangSwitcher) {
		let setLanguageOptions = (id, selectPath) => {

			//update the selected state of the country options
			let allCountryOptions = Array.prototype.slice.call(selCountrySwitch.options); //all country-options as array
			allCountryOptions.forEach(option => {
				if (option.value == id) {
					option.setAttribute('selected', 'true');
				} else {
					option.removeAttribute('selected');
				}
			});

			let defaultLang = selCountrySwitch.querySelector('option[selected="true"]').getAttribute('data-iso'); //iso-code of the default-lang
			let selDefaultLangIndex = selLangSwitch.querySelector('option[data-iso="'+defaultLang+'"][data-root="'+id+'"]').index; //index of defaultLanguage-option of selected country
			//change the langswitch to default-language
			selLangSwitch.selectedIndex = selDefaultLangIndex;

			btnLangSwitcher.setAttribute('href', '#');

			// Hide all options
			let allOptions = selLangSwitch.querySelectorAll('option:not([disabled])');
			if (allOptions.length) {
				Array.prototype.slice.call(allOptions).forEach(e => {
					if (e.getAttribute('data-root') !== id) {
						e.classList.add('hidden-language');
					} else {
						e.classList.remove('hidden-language');
						if (selectPath && selectPath == e.value) {
							e.setAttribute('selected', 'selected');
						}
					}
				});

				if (selectPath) {
					Array.prototype.slice.call(allOptions).some((e, i) => {
						if (e.hasAttribute('selected')) {
							selLangSwitch.selectedIndex = i+1;
							return true;
						}
					});
				}
			}
		};

		// Update langswitch and set correct value as selected
		if (location.pathname.match(/(^\/.+?\/.+?\/)*/i)) {
			let currentLang = RegExp.$1;
			let options = Array.prototype.slice.call(selLangSwitch.querySelectorAll('option'));
			let selectedLang = undefined;
			options.forEach(e => {
				if (e.value == currentLang) {
					selectedLang = e;
				} else {
					e.removeAttribute('selected');
				}
			});

			if (selectedLang) {
				selectedLang.setAttribute('selected', 'selected');
				setLanguageOptions(selectedLang.getAttribute('data-root'), currentLang);

				let selCountry = selCountrySwitch.querySelector(`option[value="${selectedLang.getAttribute('data-root')}"]`);
				if (selCountry) {
					selCountry.setAttribute('selected', 'true');
				}
			}
		}

		// function to create and set href-attribute of 'btnLangSwitcher' 
		function setLangSwitcherHref () {
			let hrefProtocol = 'https://';
			let hrefOrigin = window.location.host;
			let hrefLangPath = selLangSwitch.options[selLangSwitch.selectedIndex].value;
			let hrefCombined = hrefProtocol + hrefOrigin + hrefLangPath + 'index';

			btnLangSwitcher.setAttribute('href', hrefCombined);
		}

		selCountrySwitch.addEventListener('change', () => {
			setLanguageOptions(selCountrySwitch.options[selCountrySwitch.selectedIndex].value);
			setLangSwitcherHref();
		});

		selLangSwitch.addEventListener('change', () => {
			setLangSwitcherHref();
		});
	}

	// functionality to toggle the backdrop
	// Array that lists all elements that can trigger the backdrop on click
	let allBackdropTriggers = Array.prototype.slice.call(document.querySelectorAll('.js-toggleBackdrop'));
	allBackdropTriggers.forEach((trigger) => {
		trigger.addEventListener('click', (e) => {
			toggleBackdrop(trigger);
		});
	});

	// Function to toggle the backdrop
	function toggleBackdrop(backdropTrigger){
			//class to mark the trigger
		let markerClass = 'backdrop-toggled',
			// selects the body of the document
			body = document.body,
			// the class attached when toggled
			activeClass = 'backdrop-active',
			// gets the backdrop 
			backdropElem = document.querySelector('#backdrop');

		// marks the element that toggles the backdrop on
		if(!backdropTrigger.classList.contains(markerClass)) {
			backdropTrigger.classList.add(markerClass);
		} else {
			backdropTrigger.classList.remove(markerClass);
		}

		let allMarkedTriggers = Array.prototype.slice.call(document.querySelectorAll('.js-toggleBackdrop.'+markerClass+''));
		if(backdropTrigger.getAttribute('data-toggle-off-only') == 'TRUE') {
			//removes the marker class from all triggers
			allMarkedTriggers.forEach((markedTrigger) => {
				markedTrigger.classList.remove(markerClass);
			});
			body.classList.remove(activeClass);
		} else if (backdropTrigger == backdropElem) {
			//removes the marker class from all triggers
			allMarkedTriggers.forEach((markedTrigger) => {
				markedTrigger.classList.remove(markerClass);
			});
			// toggles the class on body
			if (!body.classList.contains(activeClass)) {
				body.classList.add(activeClass);
			} else {
				backdropTrigger.classList.remove(markerClass);
				body.classList.remove(activeClass);
			}
		} else if (allMarkedTriggers.length > 1) {
			//removes the marker class from all triggers but from the current
			allMarkedTriggers.forEach((markedTrigger) => {
				if (markedTrigger !== backdropTrigger) {
					markedTrigger.classList.remove(markerClass);
				}
			});
		} else {
			// toggles the class on body
			if (!body.classList.contains(activeClass)) {
				body.classList.add(activeClass);
			} else {
				backdropTrigger.classList.remove(markerClass);
				body.classList.remove(activeClass);
			}
		}
	}
	
	// Function for js-buttons
	// Array that lists all js-buttons on the document
	let allJSButtons = Array.prototype.slice.call(document.querySelectorAll('.js-button'));
	allJSButtons.forEach((jsButton) => {
		jsButton.addEventListener('click', (e) => {
			toggleJSButton(jsButton);
		});
	});

	function toggleJSButton(jsButton) {
		let elemClass = 'clicked',
			// gets all clicked js-buttons
			allClickedJSButtons = Array.prototype.slice.call(document.querySelectorAll('.js-button.'+elemClass+'')); 

		if(!jsButton.classList.contains(elemClass)) {
			// only 1 Button can be in 'clicked-mode' at a time 
			if(allClickedJSButtons.length > 0){
				allClickedJSButtons.forEach((clickedJSButton) => {
					clickedJSButton.classList.remove(elemClass);
				});
			}
			jsButton.classList.add(elemClass);
		} else {
			jsButton.classList.remove(elemClass);
		}
	}

	// Function to toggle on or toggle off any Element via a trigger button
	// Array of all the toggle triggers on the Document
	let allTogglesTriggers = Array.prototype.slice.call(document.querySelectorAll('.js-toggleTrigger'));
	allTogglesTriggers.forEach((toggleTrigger) => {
		// gets the id of the toggle's target as a string 
		let toggleTargetString = toggleTrigger.getAttribute('data-target'),
		// gets the target of the toggle 
		toggleTarget = document.querySelector('#'+toggleTargetString+''),
		// the class to add when the target is toggled
		classToggled = 'toggled',
		// gets all toggles with this target
		allSameTargetToggles = Array.prototype.slice.call(document.querySelectorAll('.js-toggleTrigger[data-target="'+toggleTargetString+'"]'));
		 
		if(toggleTrigger.getAttribute('data-toggle-off-only') == 'TRUE') {
			// adds a click-event to all the toggle elements on the Document
			toggleTrigger.addEventListener('click', (e) => {
				toggleTarget.classList.remove(classToggled);
				allSameTargetToggles.forEach((sameTargetToggle) => {
					if (sameTargetToggle.classList.contains('js-button')) {
						toggleJSButton(sameTargetToggle);
					}
				});
			});
		} else {
			// adds a click-event to all the toggle elements on the Document
			toggleTrigger.addEventListener('click', (e) => {	
					// gets all toggled elements
				let allToggledElems = Array.prototype.slice.call(document.querySelectorAll('.'+classToggled+''));
				
				if (!toggleTarget.classList.contains(classToggled)) {
					if (allToggledElems.length > 0) {
						allToggledElems.forEach((toggledElem) => {
							toggledElem.classList.remove(classToggled);
						});
					}
					toggleTarget.classList.add(classToggled);
				} else {
					toggleTarget.classList.remove(classToggled);
				}
			});
		}

		// toggle off the target when the backdrop is clicked
		if (toggleTrigger.classList.contains('js-toggleBackdrop')) {
			let backdrop = document.querySelector('#backdrop');
			if (backdrop) {
				let resetState = function(triggerBtn) {
					if (toggleTarget.classList.contains(classToggled)) {
						toggleTarget.classList.remove(classToggled);
						// toggles the backdrop
						toggleBackdrop(triggerBtn);
						if (toggleTrigger.classList.contains('js-button')){
							// trigger the button to close/open the main-navigation
							toggleJSButton(toggleTrigger);
						}
					} 
				};

				backdrop.addEventListener('click', (e) => {
					resetState(toggleTrigger);
				});

				// toggle off on pressing 'esc'
				document.addEventListener('keyup', (e) => {
					// on press 'ESC' (keyCode 27)
					if (e.keyCode === 27) {
						resetState(toggleTrigger);
					}
				});
			}
		}
	});

	/**
	 * START: functionality for the main-navigation
	*/
	
	/**
	 * Function to switch the sites inside the navigation
	 * 
	 * @param e			HTML-Element	the page-link that triggered the click-event to call the function
	 * @param context 	HTML-Element	Container of the page-link where it triggered the click-event	
	 * @param allLinks 	Array			List of all the page-links inside the current context
	 */
	function switchNavpoint(e,context,allLinks){
			// ID of the clicked page-link
		let pageId = e.getAttribute('data-pageuid'),
			// the content connected to the clicked page-link identified by the ID
			pageIdChildren = context.querySelector('.js-pageChildren[data-pagechildrenid="'+pageId+'"]'), 
			// Array that lists all the contents inside the current navigation
			pageChildrenAll = Array.prototype.slice.call(context.querySelectorAll('.js-pageChildren')); 

		// displays the content that is connected to the clicked link
		pageChildrenAll.forEach((elem) => {
			if (elem.classList.contains('active') && elem !== pageIdChildren) {
				elem.classList.remove('active');
			} else if(elem == pageIdChildren) {
				elem.classList.add('active');
			} else {
				elem.classList.remove('active');
			}
		});

		// sets the active class of the the tab in the current tabs-content-element on the clicked tab
		allLinks.forEach((link) => {
			let listPoint = link.parentNode;
			if(listPoint.classList.contains('active') && listPoint !== e.parentNode) {
				listPoint.classList.remove('active');
			} else if(listPoint == e.parentNode) {
				listPoint.classList.add('active');
			} else {
				listPoint.classList.remove('active');
			}		
		});
	}

	// when a page-link is clicked the switchNavpoint function is called
	let mainNavi = document.querySelector('.js-mainNavigation');
	if (mainNavi) {
		// Array that lists all page-links inside main-navigation of the Document
		let allLinks = Array.prototype.slice.call(mainNavi.querySelectorAll('.js-pageLinkList li .js-pageLink'));

		allLinks.forEach((elem) => {
			// adds a click-event to all the page-links in the Navigation of the Document
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				// gets the clicked page-link
				let elem = e.target,
					// gets the container of all the page-links
					pageLinksContainer = mainNavi.querySelector('.js-pageLinkList'),
					// gets the container of all the contents connected to the page-links
					pageChildrenContainer = mainNavi.querySelector('.js-pageChildrenContainer'),
					// Array that list all the page-links inside the navigation where the click-event was triggered
					currentLinks = Array.prototype.slice.call(pageLinksContainer.querySelectorAll('li a'));
				
				// calls the funtion that makes it possible to switch pages
				switchNavpoint(elem,pageChildrenContainer,currentLinks);
			});
		});
	}

	/**
	 * END: functionality for the main-navigation
	*/


	// Setting the first menu element as the active one, prevents empty menu
	if (document.querySelectorAll('.js-pageLinkList') && !document.querySelectorAll('.js-pageLinkList .active').length) {
		let firstItem = document.querySelector('.js-pageLinkList li:first-child');
		if (firstItem) {
			firstItem.classList.add('active');
		}

		let subItems = document.querySelector('.js-pageChildrenContainer .js-pageChildren:first-child');
		if (subItems) {
			subItems.classList.add('active');
		}
	}

	// Hide unnecessary content if no Cookiebot is available.
	if (typeof(Cookiebot) === 'undefined') {
		$(".cookieconsent-optin-marketing").css(
			{
				"display": "none"
			}
		);
		$(".contentblockerinfo").css(
			{
				"display": "none"
			}
		);
	}


})();


/**
Search Focus
*/

$( ".search-button" ).click(function() {
	$( ".input__search" ).focus();
});